import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ft_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Resolve image url: uploaded files are served via /api/files/..., external ones pass through
export function resolveImg(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
}

export default api;
